$(document).on("turbolinks:load", function () {
  $(".js-expand-truncated").click(function (event) {
    event.preventDefault();
    $(this).siblings(".text-truncate").removeClass("text-truncate");
    $(this).remove();
  });
});
